import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./admin-fee-button.module.css";
var AdminFeeButton = function(param) {
    var onAdminFeeClick = param.onAdminFeeClick;
    return /*#__PURE__*/ _jsx("button", {
        onClick: onAdminFeeClick,
        "aria-label": "Plus a \xa399 admin fee. Find out more info",
        className: styles.adminFeeInfoButton,
        children: "Plus a \xa399 admin fee"
    });
};
export default AdminFeeButton;
